export const mockedpermissions = [{ locationId: 2, locationName: 'Root', permissions: 16383 }];
